import { render, staticRenderFns } from "./SessionDetailsTab.vue?vue&type=template&id=9a3771e6&scoped=true&"
import script from "./SessionDetailsTab.vue?vue&type=script&lang=js&"
export * from "./SessionDetailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a3771e6",
  null
  
)

export default component.exports